import { FC, ReactNode } from 'react';
import { Button, Typography } from '@mui/material';

import styles from './CustomButton.module.scss';

type CustomButtonProps = {
  children: string | ReactNode;
  variant?: 'contained' | 'text' | 'outlined';
  disabled?: boolean;
  btnType?: 'submit' | 'button';
  customClass?: string;
  onClick?: (() => void) | ((event: React.MouseEvent<HTMLButtonElement>) => void);
}

const CustomButton: FC<CustomButtonProps> = ({ children, variant = 'contained', disabled = false, btnType = 'button', customClass, onClick }) => (
  <Button
    id={styles.customBtn}
    type={btnType}
    variant={variant}
    className={`${customClass} ${variant === 'contained' ? styles.defaultPrimary : styles.defaultSecondary}`}
    disabled={disabled}
    onClick={onClick}
  >
    <Typography variant='h10Bold'>
      {children}
    </Typography>
  </Button>
);

export default CustomButton;
